// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_BIFEz","itemLink":"index_itemLink_3rU4W","itemPic":"index_itemPic_vv5pJ","itemAction":"index_itemAction_1FGIf"};